/** @jsx jsx */
import { css } from '@emotion/core';
import { unset } from 'lodash';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography } from '../../../styles/typography';

export const containerMarginCss = css({
  margin: '64px 0',

  [MediaQueries.lg]: {
    margin: '96px 0 0',
  },
  [MediaQueries.md]: {
    margin: '96px 0 0',
  },
  [MediaQueries.sm]: {
    margin: '64px 0 64px',
  },
});

export const quoteTextCss = css(typography.effra34, {
  marginBottom: 28,
  fontSize: '32px !important',
  position: 'relative',
  lineHeight: '32px',
  letterSpacing: '-0.4px',
  left: 16,
  [MediaQueries.mdAndUp]: {
    marginBottom: 16,
    fontSize: '32px !important',
    letterSpacing: '-0.4px',
    lineHeight: '32px',
    left: 0,
  },
  [MediaQueries.lgAndUp]: {
    marginTop: 56,
    marginBottom: '64px',
  },
  [MediaQueries.sm]: {
    marginBottom: '16px',
    position: 'unset',
    marginLeft: '0px',
    marginRight: '15px',
  },
});

export const initialQuote = css({
  position: 'absolute',
  left: -16,
  [MediaQueries.sm]: {
    position: 'unset',
  },
});

export const blockquoteCss = css({
  [MediaQueries.mdAndUp]: {
    paddingLeft: 16,
  },
  [MediaQueries.sm]: {
    marginBottom: '48px',
  },
  [MediaQueries.md]: {
    marginBottom: '48px',
  },
});

export const attributionCss = css({
  alignItems: 'center',
  display: 'flex',
  height: 60,
  marginBottom: 40,
  position: 'relative',
  left: unset,
  [MediaQueries.mdAndUp]: {
    marginBottom: 32,
    left: 0,
  },

  [MediaQueries.md]: {
    left: 'unset',
  },
});

export const headshotCss = css({
  marginRight: 15,
  borderRadius: '50%',
  display: 'inline-block',
  height: 40,
  width: 40,
  overflow: 'hidden',
});

export const imageCss = css({
  height: 40,
  width: 40,
});

export const attributionMainTextCss = css({
  color: colorsPalette.teal,
  marginBottom: 7,
});

export const attributionSecondaryTextCss = css({
  color: '#616161',
});

export const readTheFullStoryCtaCss = css({
  marginBottom: 64,
  [MediaQueries.mdAndUp]: {
    marginBottom: 40,
    width: 215,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 1,
  },
});

export const carouselColumnCss = css({
  maxWidth: '100%',
});

export const spacerCss = css({
  overflow: 'hidden',
});

export const ctaContainer = css({
  padding: '0 1px',
  alignItems: 'center',
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  borderRadius: '4px',
  justifyContent: 'center',
  border: '#d7d7d7 solid 1px',
  height: '56px',
  minWidth: '100px',
  outline: 'none',
  padding: '0 24px',
  textAlign: 'center',
  textDecoration: 'none',
  width: '100%',
  fontSize: '14px',
  fontWeight: 500,
  maxWidth: '279px',
  lineHeight: 1.14,
  letterSpacing: '0.87px',
  textTransform: 'uppercase',
  background: 'transparent',
  color: '#393939',
  flexDirection: 'row',
  marginBottom: '0px',
  [MediaQueries.sm]: {
    maxWidth: '100%',
    marginLeft: '0px',
  },

  a: {
    textDecoration: 'none',
    color: '#616161',
    [MediaQueries.sm]: {
      marginBottom: '0px',
    },
    [MediaQueries.md]: {
      marginBottom: '0px',
    },
  },
});

export const carouselCss = css({
  ul: {
    width: 910,
    position: 'initial',
    display: 'flex',
    flexDirection: 'row',
  },
});
